import getAPIResponse from "Shared/Utils/Domain/Services/GetAPIResponsePrivateService";
import { ServiceCompany } from "../../Model/ServiceCompany/ServiceCompany";

export async function patchServiceCompanyService(id, data) {
    let response = await getAPIResponse("/v1/service-company/" + id, data, "PATCH");
    if (response === null) {
        return null;
    }
    return ServiceCompany.createFormResponseData(response);
}